import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Container } from 'reactstrap';
import BISlogoblue from 'assets/img/bis/logo2.png'
import { useCookies } from 'react-cookie';
import CustomToast from '../utils/CustomToast';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const initialBookingData = Object.freeze({
    id: '',
    award: {
        id: 0
    },
    code: '',
    digital_attendees: 0,
    digital_attendees_total: 0,
    live_attendees: 0,
    performance_benchmark: 0,
    status: '',
    total_amount: 0,
    subtotal_amount: 0,
    winner_package: 0,
    irish_times_coverage: 0,
    global_broadcast: 0,
    all_features: 0,
    live_attendees_tables: 0,
    live_attendees_individuals: 0,
    po_number: "",
    line_items: [],
    additional_10_seats: 0,
});

const VerifyEmailPage = () => {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    let query = useQuery();
    const booking_id = query.get('booking_id');
    const booking_code = query.get('booking_code');
    const method = query.get('method');
    const action = query.get('action');
    const po = query.get('po');
    const type = query.get('type');
    const [cookies, setCookie, removeCookie] = useCookies(['currentUser', 'isLoggedIn', 'award_id', 'section', 'failsafe_award_id', 'userRole']);

    const currentUser = cookies.currentUser;
    const token = cookies.token;
    const userRole = cookies.userRole;
    const section = cookies.section;

    const [bookingData, setBookingData] = useState(initialBookingData);
    const [bookingLoading, setBookingLoading] = useState(true);
    let history = useHistory();

    const [formStatus, setFormStatus] = useState(false);

    const getBooking = async () => {
        return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'booking/' + booking_code + '/details/v2');
    };

    const postResendVerification = async () => {
        return await axios.post(
            process.env.REACT_APP_API_ENDPOINT + `user/${currentUser}/resend/verification`, { section: section, booking_id: booking_id, booking_code: booking_code, method: method, po: po, type: type },
            {
                params: {
                    user_id: currentUser,
                    token: token,
                },
            },
        );
    };

    const toggleResendVerification = () => {
        setFormStatus(true);

        postResendVerification().then(response => {
            const status = response.data.status;
            if (status === 'Success') {
                CustomToast.success("A verification email has been sent. Please check your inbox.")
                setFormStatus(false);
            } else {
                CustomToast.defaultWarning();
                setFormStatus(false);
            }
        }).catch(() => {
            CustomToast.defaultError();
            setFormStatus(false);
        });
    }

    const getUser = async (booking_data) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}profile/${currentUser}`,
                {
                    params: {
                        user_id: currentUser,
                        token: token,
                    },
                }
            );
    
            const data = response.data.data;
            if (data) {
                if (data.new_user === '1' && data.email_verified_at !== '') {
                    if (userRole) {
                        if (booking_data) {
                            // let redirectUrl = `/stripe?code=${booking_code}&award_code=${booking_data.award.award_type.code.replace('&', '%26')}${booking_data.first_name === 'Jeno (Test)' ? '&test=1' : booking_data.first_name === 'BR 1Eur Test' ? '&oneeuro=1' : ''}`;
    
                            // if (method === 'bt') {
                            //     redirectUrl = `/bank/transfer?award_id=${booking_data.award.id}&booking_code=${booking_code}&po_number=${booking_data.po_number}&po=${po ? po : ''}`;
                            // }
                            let redirectUrl = `/booking/summary/unlisted?booking_id=${booking_id}&booking_code=${booking_code}${method ? '&method=' + method : ''}${po ? '&po=' + po : ''}`;
                            if (type === 'listed'){
                                redirectUrl = `/booking/summary?booking_id=${booking_id}&booking_code=${booking_code}${method ? '&method=' + method : ''}${po ? '&po=' + po : ''}`;
                            }
                            window.location.href = redirectUrl;
                            
                        } else {
                            if(action === 'finance_access_onboarding'){
                                history.push(`/sponsor/home`); 
                            } else if (action === 'panelist_access_onboarding') {
                                history.push(`/panelist/confirmation`);
                            } else if (userRole === 'Entrant') {
                                if (section) {
                                    history.push(`/${section}/home`); 
                                } else {
                                    history.push(`/entrant/home`); 
                                }
                            } else if (userRole === 'Admin') {
                                history.push(`/admin`);
                            }
                        }
                    }
                }
                setBookingLoading(false);
            }
        } catch (error) {
            CustomToast.defaultError();
            console.error('getUser error:', error);
        }
        
    }

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                if (booking_code) {
                    const response = await getBooking();
                    const { errors, data } = response.data;
                    if (!errors) {
                        setBookingData(data);
                        await getUser(data);
                    } else {
                        CustomToast.defaultWarning();
                    }
                } else {
                    await getUser(null);
                    setBookingLoading(false);
                }
            } catch {
                CustomToast.defaultError();
            }
        }, 3000);
    
        return () => clearInterval(interval);
    }, [currentUser, userRole, section, booking_code]); 

    return (
        <>
            <ToastContainer style={{ width: '370px' }} />
            <div className="VEPbackground d-flex align-items-center pt-5 pb-5">
                <Container className="d-flex justify-content-center">
                    <Row
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'white'
                        }}
                        className="login-registration-row">
                        <Col lg={12} className="pt-3 pb-4 px-4" style={{ backgroundColor: '#fff' }}>
                            <div className='text-center mt-3 mb-3'>
                                <img
                                    src={BISlogoblue}
                                    className="rounded"
                                    style={{ height: 60 }}
                                    alt="logo"
                                />
                            </div>
                            <p className="text-center text-primary mb-1" style={{ fontWeight: 'bold', fontSize: '24px' }}>JUST ONE STEP AWAY</p>
                            <p className="text-center mb-4" style={{ fontWeight: '600' }}>Verify Your Email</p>
                            <p className='mb-3'>Welcome to <strong>Business River</strong>. We're excited to have you join us. To complete your sign-up, we've just sent you a verification email.</p>
                            <p className='text-muted' style={{ fontSize: '14px' }}><i>Please check your inbox (and your spam folder, just in case) for the verification email and follow the instructions to confirm your email address.</i></p>
                            <hr />
                            <p className="text-center mb-1" style={{ fontWeight: '700' }}>Haven't received the email yet?</p>
                            <p className="small text-center mb-3">No problem-just click the button below to resend it.</p>
                            {bookingLoading ?
                                <div className='text-center'>
                                    <button className='btn btn-primary' disabled ><span class="small" style={{ fontWeight: '600' }}>VERIFYING YOUR ACCOUNT...</span></button>
                                </div>
                                :
                                <div className='text-center'>
                                    {formStatus ?
                                        <>
                                            <button className='btn btn-primary' disabled ><span class="small" style={{ fontWeight: '600' }}>RESENDING...</span></button>
                                        </>
                                        :
                                        <>
                                            <button className='btn btn-primary' onClick={toggleResendVerification} ><span class="small" style={{ fontWeight: '600' }}>RESEND VERIFICATION EMAIL</span></button>
                                        </>
                                    }
                                </div>
                            }
                            
                            {/* <p className='mb-2 mt-5'>Once you're verified, you'll be ready to dive into everything we have to offer.</p><p className='mb-2'>Looking forward to seeing you in The Peer Club!</p> */}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default VerifyEmailPage;
